import { useTiktokCampaigns } from './useTiktokCampaigns';
import { ExpandedState } from '@tanstack/react-table';
import useUrlState from 'Hooks/useUrlState';
import { useMemo } from 'react';
import PublicReportTiktokPostsTable from 'Modules/Plans/PublicReports/Posts/TiktokPosts/PublicReportTiktokPostsTable';
import TikTokPublicReportCampaignTable from '../CampaignsTable/TikTokPublicReportCampaignTable';

type UrlState = Partial<{
    expanded: string;
}>;

const ReportTiktokCampaigns = () => {
    const [urlState, setUrlState] = useUrlState<UrlState>();
    const {
        rows,
        isCampaignsLoading,
        isCampaignsError,
        isProjectsLoading,
        isBrandLoading,
        isTeamsLoading,
        isCampaignStatsLoading,
        isTimeSeriesLoading,
        isTimeSeriesError,
    } = useTiktokCampaigns();

    const expandedState = useMemo(() => {
        const expanded = urlState?.expanded;
        if (!expanded) {
            return {};
        }

        return expanded.split(',').reduce(
            (acc, campaignId) => {
                acc[campaignId] = true;
                return acc;
            },
            {} as Record<string, boolean>
        );
    }, [urlState]);

    const setExpandedState = (expanded: ExpandedState) => {
        const expandedKeys = Object.keys(expanded).filter((key) => expanded[key as keyof ExpandedState]);
        setUrlState({ expanded: expandedKeys.join(',') });
    };

    return (
        <TikTokPublicReportCampaignTable
            data={rows}
            meta={{
                isLoading: isCampaignsLoading,
                getIsProjectLoading: () => isProjectsLoading,
                getIsTeamLoading: () => isTeamsLoading,
                getIsBrandLoading: (row) => isBrandLoading(row.id),
                getIsCampaignStatsLoading: (row) => isCampaignStatsLoading(row.id),
                getIsTimeSeriesLoading: () => isTimeSeriesLoading,
                getTimeSeriesHasError: () => isTimeSeriesError,
            }}
            isLoading={isCampaignsLoading}
            hasError={isCampaignsError}
            expandedState={expandedState}
            onExpandedChange={setExpandedState}
            renderSubComponent={(row) => <PublicReportTiktokPostsTable campaign={row.original} />}
        />
    );
};

export default ReportTiktokCampaigns;
